import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';
import { RootState } from '@spa/lib/store//RootState';
import selectSessionContent from '@spa/lib/store/session/selectors/selectSessionContent';

const selectSessionLatestSelectedDeliveryMethod = (state: RootState): CustomOrderType => {
  const { latestSelectedDeliveryMethod } = selectSessionContent(state);
  return latestSelectedDeliveryMethod ?? CustomOrderType.HOME_DELIVERY;
};

export default selectSessionLatestSelectedDeliveryMethod;
